import React, { useState, useEffect } from "react";
import "../../assets/css/BottomSheet.css";

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  customStyles?: React.CSSProperties;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  children,
  customStyles,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll"); // Disable background scrolling
      setIsVisible(true);
      setIsAnimating(true);
    } else {
      setIsAnimating(true);
      setTimeout(() => {
        document.body.classList.remove("no-scroll"); // Enable background scrolling
        setIsVisible(false);
        setIsAnimating(false);
      }, 500); // Match animation duration (0.5s)
    }
  }, [isOpen]);

  return (
    <>
      {isVisible && (
        <>
          <div
            className={`bottom-sheet-overlay ${
              isOpen ? "fade-in" : "fade-out"
            }`}
            onClick={() => {
              if (!isAnimating) onClose();
            }}
          ></div>
          <div
            className={`bottom-sheet ${isOpen ? "slide-up" : "slide-down"}`}
            style={customStyles}
            onAnimationEnd={() => setIsAnimating(false)}
          >
            <div className="bottom-sheet-content">{children}</div>
          </div>
        </>
      )}
    </>
  );
};

export default BottomSheet;
